<template>
    <b-card class="mb-5">
        <b-row>
            <b-col md="12">
            <h3>{{$route.name}}</h3>
            <b-breadcrumb>
            <b-breadcrumb-item><router-link to="/dashboard">Dashboard</router-link></b-breadcrumb-item>
            <b-breadcrumb-item><router-link to="/my-job">My Job</router-link></b-breadcrumb-item>
            <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
            </b-breadcrumb>
            <div class="border-bottom"></div>
            </b-col>
        </b-row>
        <template v-if="isLoading">
            <div class="d-flex justify-content-center mb-5 mt-5 pt-5 pb-5">
                <b-spinner style="width: 3rem; height: 3rem;" variant="primary" label="Loading..."></b-spinner>
            </div>
        </template>
        <template v-else>
            <b-form class="mt-4 mx-2">
                <b-row>
                    <b-col md="6">
                        <b-row>
                            <b-col md="4">
                                <label class="labels">Name</label>
                            </b-col>
                            <b-col md="8">
                                <p>{{ model.userProfile !== '-' ? (model.userProfile.firstName + ' ' + (model.userProfile.lastName !== null ? model.userProfile.lastName : '')) : '-' }}</p>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="4">
                                <label class="labels">Subject</label>
                            </b-col>
                            <b-col md="8">
                                <p>{{ model.subject !==null ? model.subject : '-' }}</p>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="4">
                                <label class="labels">Start</label>
                            </b-col>
                            <b-col md="8">
                                <p>{{ model.startTime }}</p>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="4">
                                <label class="labels">End</label>
                            </b-col>
                            <b-col md="8">
                                <p>{{ model.endTime }}</p>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="4">
                                <label class="labels">Minutes</label>
                            </b-col>
                            <b-col md="8">
                                <p>{{ model.minutes }}</p>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="4">
                                <label class="labels">Status</label>
                            </b-col>
                            <b-col md="8">
                                <p><b-badge :variant="getStatusColor(model.status)">{{getStatusName(model.status)}}</b-badge></p>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col md="6">
                        <b-row>
                            <b-col md="4">
                                <label class="labels">Branch</label>
                            </b-col>
                            <b-col md="8">
                                <p>{{ model.userProfile !== '-' ? model.userProfile.branch : '-' }}</p>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="4">
                                <label class="labels">Created</label>
                            </b-col>
                            <b-col md="8">
                                <p>{{ model.createdAt !== null ? getDateTime(model.createdAt) : '-' }}</p>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="4">
                                <label class="labels">Note</label>
                            </b-col>
                            <b-col md="8">
                                <p>{{ model.note !== null ? model.note : '-' }}</p>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="4">
                                <label class="labels">Decription</label>
                            </b-col>
                            <b-col md="8">
                                <p>{{ model.desc !== null ? model.desc : '-' }}</p>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
                <b-row class="mt-3 mb-3">
                    <b-col>
                        <h5 class="pb-3">Photo</h5>
                    </b-col>
                    <b-col md="12">
                        <b-row v-if="model.jobPhotoList.length === 0">
                            <b-col md="3">
                                <p class="text-secondary text-center border p-5"><i>No Photo Submitted</i></p>
                            </b-col>
                        </b-row>
                        <viewer :images="model.jobPhotoList" v-else>
                            <b-row>
                                <b-col md="3" v-for="(src, index) in model.jobPhotoList" :key="index">
                                    <p class="text-secondary text-center border p-5" v-if="src === null"><i>No Photo Submitted</i></p>
                                    <b-img v-else :src="src" class="img-responsive" width="300" height="200"/>
                                </b-col>
                            </b-row>
                        </viewer>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <h5 class="mb-3">Timesheet Status History</h5>
                    </b-col>
                    <b-col md="12">
                        <div class="table-responsive">
                        <table class="table table-hovered table-striped">
                            <thead>
                                <tr>
                                    <th scope="col" width="100">Status</th>
                                    <th scope="col">Note</th>
                                    <th scope="col" width="200">Time</th>
                                </tr>
                            </thead>
                            <tbody v-if="jobHistoryStatusList.length > 0">
                            <tr v-for="report in jobHistoryStatusList" :key="report.uuid">
                                <td><b-badge :variant="getStatusColor(report.status)">{{getStatusName(report.status)}}</b-badge></td>
                                <td>{{report.note !== null ? report.note : '-'}}</td>
                                <td>{{report.createdAt !== null ? getDateTime(report.createdAt) : '-'}}</td>
                            </tr>
                            </tbody>
                            <tbody v-else>
                            <tr>
                                <td colspan="9" class="text-center">there's no data</td>
                            </tr>
                            </tbody>
                        </table>
                        </div>
                    </b-col>
                </b-row>
            </b-form>
            <b-button class="mt-3" @click="goBack" variant="secondary"><font-awesome-icon icon="chevron-circle-left"></font-awesome-icon> Back</b-button>
        </template>

        <b-modal id="bv-modal-example" hide-footer>
            <template v-slot:modal-title>
                <h5 class="text-transform">{{type}} job</h5>
            </template>
            <form v-on:submit.prevent="doTest(type)">
                <div class="d-block">
                    <label for=""><strong>Note</strong></label>
                    <b-form-textarea rows="3" v-model="formData.note" placeholder="Enter note"></b-form-textarea>
                </div>
                <b-button class="mt-4" @click="$bvModal.hide('bv-modal-example')"><font-awesome-icon icon="times"></font-awesome-icon> Cancel</b-button>
                <b-button variant="primary" type="submit" class="mt-4 float-right"><font-awesome-icon icon="spinner" spin v-if="isLoading"></font-awesome-icon> <font-awesome-icon icon="save" v-else></font-awesome-icon> Submit</b-button>
            </form>
        </b-modal>
    </b-card>
</template>

<script>
    import 'viewerjs/dist/viewer.css'
    import Viewer from 'v-viewer'
    import Vue from 'vue'
    Vue.use(Viewer)

    export default {
        name: 'report-show',
        data () {
            return {
                isLoading: false,
                apiUrl: {
                    job: window.AppConfig.apiUrl + 'job',
                    jobHistoryStatus: window.AppConfig.apiUrl + 'job-history-status'
                },
                type: null,
                formData: {
                    note: null
                },
                // mainProps: { blank: true, width: 75, height: 75, class: 'm1' },
                model: {
                    hour: 0,
                    userProfile: {
                        firstName: null
                    },
                    startTime: '',
                    endTime: '',
                    status: '',
                    note: '',
                    desc: '',
                    createdAt: '',
                    changedBy: '',
                    position: {
                        lat: 0,
                        lng: 0
                    },
                    jobType: null,
                    statusText: '',
                    statusValue: '',
                    statusTime: '',
                    statusTextTime: '',
                    jobPhotoList: [],
                    subject: ''
                },
                jobHistoryStatusList: []
            }
        },
        mounted () {
            this.getDetail()
            this.getHistoryStatus()
        },
        methods: {
            showModal (type) {
                this.formData.note = null
                this.type = type
                this.$bvModal.show('bv-modal-example')
            },
            doTest (type) {
                console.log('do test')
                this.isLoading = true
                this.$http.post(window.AppConfig.apiUrl + 'job-action', {
                    uuid: this.$route.params.uuid,
                    action: type,
                    note: this.formData.note
                })
                .then(() => {
                    this.isLoading = false
                    // this.formData.note = null
                    // this.getDetail()
                    // this.getHistoryStatus()
                    // this.$bvModal.hide('bv-modal-example')
                    // this.$store.dispatch('notification/success', 'job has been approve')
                })
                .catch(error => {
                    this.isLoading = false
                    this.$store.dispatch('notification/error', error)
                });
            },
            doChangeStatus (type) {
                this.isLoading = true
                this.$http.post(window.AppConfig.apiUrl + 'job-action', {
                    uuid: this.$route.params.uuid,
                    action: type,
                    note: this.formData.note
                })
                .then(() => {
                    this.isLoading = false
                    this.formData.note = null
                    this.getDetail()
                    this.getHistoryStatus()
                    this.$bvModal.hide('bv-modal-example')
                    this.$store.dispatch('notification/success', 'job has been approve')
                })
                .catch(error => {
                    this.isLoading = false
                    this.$store.dispatch('notification/error', error)
                });
            },
            getDetail () {
                this.isLoading = true
                this.$http.get(this.apiUrl.job + '/' + this.$route.params.uuid)
                .then(response => {
                    this.model.userProfile = response.data.userProfile !== null ? response.data.userProfile : '-'
                    this.model.startTime = response.data.startTime !== null ? this.$moment(response.data.startTime).format('YYYY-MM-DD hh:mm a') : '-'
                    this.model.endTime = response.data.endTime !== null ? this.$moment(response.data.endTime).format('YYYY-MM-DD hh:mm a') : '-'
                    this.model.status = response.data.status !== null ? response.data.status : '-'
                    this.model.note = response.data.note !== null ? response.data.note : '-'
                    this.model.desc = response.data.desc !== null ? response.data.desc : '-'
                    this.model.minutes = response.data.minutes !== null ? response.data.minutes : 0
                    this.model.createdAt = response.data.createdAt !== null ? response.data.createdAt : '-'
                    this.model.subject = response.data.subject
                    this.model.jobPhotoList = []
                    if (response.data.jobPhoto !== null) {
                        response.data.jobPhoto.forEach(data => {
                            this.model.jobPhotoList.push(data.url)
                        })
                    }
                    this.isLoading = false
                })
                .catch(error => {
                    this.isLoading = false
                    this.$store.dispatch('notification/error', error)
                })
            },
            getHistoryStatus () {
                this.isLoading = true
                this.$http.get(this.apiUrl.jobHistoryStatus + '?job_uuid=' + this.$route.params.uuid + '&ascending=1').then(response => {
                    this.jobHistoryStatusList = []
                    response.data._embedded.jobHistoryStatus.forEach(data => {
                        this.jobHistoryStatusList.push(data)
                    })
                    this.isLoading = false
                })
            },
            getDateTime (value) {
                if (value !== null) {
                    return this.$moment(value).format('YYYY-MM-DD HH:mm A')
                } else {
                    return '-'
                }
            },
            goBack () {
                window.goBack(this)
            },
            getStatusColor (val) {
                switch (val) {
                case 'Completed':
                    return 'success'
                    // eslint-disable-next-line no-unreachable
                    break
                case 'New':
                    return 'warning'
                    // eslint-disable-next-line no-unreachable
                    break

                case 'In Progress':
                    return 'warning'
                    // eslint-disable-next-line no-unreachable
                    break

                case 'Finished':
                    return 'success'
                    // eslint-disable-next-line no-unreachable
                    break
                }
            },

            getStatusName(val){
                switch(val){
                    case 'Completed':
                    return 'Finished'
                    // eslint-disable-next-line no-unreachable
                    break

                    case 'New':
                    return 'In Progress'
                    // eslint-disable-next-line no-unreachable
                    break
                }
            }
        }
    }
</script>